
import { defineComponent } from 'vue'

// skipcq: JS-0322
interface ZStepT extends Vue {}

interface ZStepperT extends Vue {
  steps: Array<ZStepT>
}

export default defineComponent({
  name: 'ZStep',
  props: {
    title: {
      required: false,
      default: undefined,
      type: String
    },
    description: {
      required: false,
      default: undefined,
      type: String
    },
    status: {
      required: false,
      type: String,
      default: 'default',
      validator: (value: string) => {
        return ['default', 'active', 'completed'].includes(value)
      }
    }
  },
  data() {
    return {
      index: -1,
      showNumbers: false,
      internalStatus: 'default',
      align: 'horizontal'
    }
  },
  computed: {
    currentStatus(): string {
      return this.status || this.internalStatus
    },
    isLast(): boolean {
      const parent = this.$parent as ZStepperT
      // @ts-expect-error - investigate the infinitely typed issue
      return parent.steps[parent.steps.length - 1] === this
    }
  },
  beforeCreate() {
    const parent = this.$parent as ZStepperT
    parent.steps.push(this)
  },
  beforeDestroy() {
    const parent = this.$parent as ZStepperT,
      steps = parent.steps
    // @ts-expect-error - investigate the infinitely typed issue
    const index = steps.indexOf(this)
    if (index >= 0) {
      steps.splice(index, 1)
    }
  }
})
